import * as i0 from "@angular/core";
export class AppendToBodyModule {
}
AppendToBodyModule.ɵfac = function AppendToBodyModule_Factory(t) { return new (t || AppendToBodyModule)(); };
AppendToBodyModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppendToBodyModule });
AppendToBodyModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
